import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import type { ComposeViewState } from 'owa-calendar-compose-types';
import { fetchFullCalendarEventAndUpdateItemResponseShapeType } from 'owa-calendar-forms-common/lib/helpers/eventStore';
import {
    InfoBarMessageViewState,
    InfoBarMessageSource,
} from 'owa-info-bar/lib/schema/InfoBarMessageViewState';
import { InfoBarViewStates } from 'owa-calendar-info-bar/lib/utils/allViewStates';
import { lazyOperateContent } from 'owa-editor';
import { toJS } from 'mobx';
import { onUpdateBodyValueOfEvent } from 'owa-calendar-compose-form-actions';

export default (event: CalendarEvent, viewState?: ComposeViewState): InfoBarMessageViewState[] => {
    let showBlockedExternalContent = async () => {
        const {
            fullEventPromise,
        } = fetchFullCalendarEventAndUpdateItemResponseShapeType(
            event.ItemId,
            'WithBlockedExternalContent',
            null,
            () => event as CalendarEvent /* getExistingCalendarEvent */,
            false /** isfetchFullSeriesMasterCalendarEventFromEventInstance */,
            { fetchSource: 'FullComposeEdit' }
        );
        let newEvent = toJS(await fullEventPromise);
        const newContent = newEvent?.Body?.Value ?? '';
        lazyOperateContent.import().then(operateContent =>
            operateContent(viewState.bodyViewState, editor => {
                editor.addUndoSnapshot(
                    () => editor.setContent(newContent),
                    'CalendarShowBlockedExternalContentInFullCompose'
                );
                return editor.getSelectionRange();
            })
        );
        onUpdateBodyValueOfEvent(newContent, newEvent?.HasBlockedImages);
    };

    return event.HasBlockedImages
        ? [
              InfoBarViewStates.getInfobarViewStateForBlockedExternalContent({
                  showBlockedExternalContent: showBlockedExternalContent,
                  source: InfoBarMessageSource.Compose,
              }),
          ]
        : [];
};
